module.exports = __webpack_public_path__ + "img/2019-11-06.16af1b4e.jpg";